/**
 * The search term and its category travel through the URL as a single
 * `search` param, encoded as `category:(term)`. Keeping both in one param is
 * the wire contract the list endpoints already expect, and it is what makes a
 * scoped search survive a reload or a shared link.
 *
 * Ported from the legacy ConnectedDataManagerSearch, which encodes the same
 * shape (and matches AngularJS's emma-ui `search` component).
 */

// Matches `vendor:(some term)` — the category key is restricted so a plain
// term containing a colon (e.g. "note: urgent") is not mistaken for a scope.
const CATEGORY_SEARCH_MATCHER = /^[a-zA-Z0-9_-]+:\((.*)\)$/

export interface IDecodedSearchTerm {
  /** Undefined when the term carries no scope. */
  category?: string
  searchTerm?: string
}

export const decodeSearchTerm = (search?: string): IDecodedSearchTerm => {
  if (!search) return { searchTerm: search }

  const match = search.match(CATEGORY_SEARCH_MATCHER)

  if (!match) return { searchTerm: search }

  return {
    category: search.split(':')[0],
    searchTerm: match[1],
  }
}

/**
 * A falsy `categoryKey` means "no scope" — the convention the AngularJS
 * search component uses for its "All" entry ({ value: null, label: 'All' }).
 */
export const formatSearchWithCategory = (
  searchTerm?: string,
  categoryKey?: Nullable<string>
): string | undefined => {
  if (!searchTerm || !categoryKey) return searchTerm

  return `${categoryKey}:(${searchTerm})`
}
